const committedCoverBlobOwnerCounts = new Map<string, number>();

function retainCommittedCoverBlobUrl(url: string) {
  committedCoverBlobOwnerCounts.set(
    url,
    (committedCoverBlobOwnerCounts.get(url) ?? 0) + 1
  );
}

function releaseCommittedCoverBlobUrl(url: string) {
  const ownerCount = committedCoverBlobOwnerCounts.get(url);
  if (ownerCount === undefined) {
    return;
  }

  if (ownerCount > 1) {
    committedCoverBlobOwnerCounts.set(url, ownerCount - 1);
    return;
  }

  committedCoverBlobOwnerCounts.delete(url);
  URL.revokeObjectURL(url);
}

export function reconcileCommittedCoverBlobUrls(
  ownedUrls: Set<string>,
  currentUrls: Iterable<string>
) {
  const nextUrls = new Set(currentUrls);

  for (const url of nextUrls) {
    if (!ownedUrls.has(url)) {
      retainCommittedCoverBlobUrl(url);
    }
  }

  for (const url of ownedUrls) {
    if (!nextUrls.has(url)) {
      releaseCommittedCoverBlobUrl(url);
    }
  }

  ownedUrls.clear();
  for (const url of nextUrls) {
    ownedUrls.add(url);
  }
}

export function releaseCommittedCoverBlobUrls(ownedUrls: Set<string>) {
  for (const url of ownedUrls) {
    releaseCommittedCoverBlobUrl(url);
  }
  ownedUrls.clear();
}
